import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "状态", -1)
const _hoisted_2 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "签到地址", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（添加后才能签到打卡）", -1)
const _hoisted_6 = { style: {"flex":"1 1 0%","text-align":"right"} }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "总潜力业务量（票数/月）", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "总TPR（票数/月）", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "总潜力物流费用（元/月）", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "总TPR（元/月）", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "总潜力重量（KG/月）", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "总TPR（KG/月）", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "主账号前三个月平均发货票数", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "当前账号前三个月平均发货票数", -1)
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "潜力业务量（票数/月）", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "发货潜力（元/月）", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "发货潜力（KG/月）", -1)
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "物流商", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（务必填写云途份额）", -1)
const _hoisted_27 = {
  key: 0,
  style: {"flex":"1 1 0%","text-align":"right"}
}
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "flex" }

import { onMounted, watch, ref, PropType, reactive, computed } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { potentialAdd, potentialEdit, turnedDeal } from '@/api/yuntuSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import {
  useRoute
  // useRouter
} from 'vue-router'
import { contactValidate, concatNameValidate, arrayValueValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import { goBack } from '@/hooks/cosRouter'
import MapModal from '@/components/MapModal/index.vue'
import { usePermissionStore } from '@/stores/permission'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { isChannelDisabled } from '@/hooks/useChannel'
import {
  // checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'

const __default__ = { name: 'customerCenterBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  view: {
    type: Boolean
  },
  data: {
    type: Object as PropType<PotentialItem>
  },
  /// 这个代表所有可编辑情况，既包含新增又包含编辑
  isEdit: {
    type: Boolean,
    required: true
  },
  /// 这个仅代表编辑
  isEditPotentialOrDeal: {
    type: Boolean,
    required: false
  },
  type: {
    type: String as PropType<'potential' | 'clients'>,
    default: 'potential' // 潜在，clients成交的基本信息 turnToDeal 转成交
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  perfect: {
    type: Boolean,
    default: false
  },
  content: {
    type: Array as PropType<'customerInfo' | 'contact' | 'business'[]>,
    default: () => {
      return ['customerInfo', 'contact', 'business']
    }
  },
  hideOk: {
    type: Boolean
  },
  returnName: String
},
  setup(__props) {

const route = useRoute()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const initForm = reactive<PotentialItem>({
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}],
    logisticsProviderInfo: [{}],
    goodsCategoryInfo: [{}]
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const form = ref<any>(cloneDeep(initForm))

const totalTprWeight = computed(() => {
  const result = form.value.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.tprWeight || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})

const tprTotal = computed(() => {
  const result = form.value.business.demandInfo.reduce(
    (prev: number, item: any) => calc.Add(prev, item.amount || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const tprPotential = computed(() => {
  const result = form.value.business.demandInfo.reduce(
    (prev: number, item: any) => calc.Add(prev, item.potentialBusinessVolume || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const props = __props
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      // 转成交 ，清掉客户状态
      const formVal = v
      initObjectVal(formVal, initForm)
      if (route.path.includes('/lbu/turnToDeal')) {
        formVal.customerInfo.status = 30
      }
      form.value = formVal
      resetValue.value = cloneDeep(form.value)
    } else {
      form.value = cloneDeep(initForm)
      form.value.customerInfo.status = 10
    }
  },
  { immediate: true }
)

const clearMainAddressFlag = (index: number) => {
  if (form.value.visitAddress) {
    for (const [i, item] of form.value.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}

const checkAddressValidate = (rule: any, value: number | string, arr: any) => {
  const list = arr || []

  if (list.filter((item: any) => item.addressTag === 1223).length > 1) {
    return Promise.reject(new Error('地址类型【总部（决策地）】只能选择1个'))
  }

  if (!rule.required) {
    return Promise.resolve()
  }
  const defaultVal = -9
  if (value == null || value === '' || value === defaultVal || value === rule.filterVal) {
    return Promise.reject(new Error('请选择'))
  } else {
    return Promise.resolve()
  }
}

const percentValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入在售平台占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.salePlatformId && item.salePlatformId !== -9) ? Promise.reject(new Error('请输入在售平台占比')) : Promise.resolve()
    }
  }
  if (value == null || value === 0) {
    return Promise.reject(new Error('请输入在售平台占比'))
  }
  let result = 0
  if (form.value.business && form.value.business.saleInfo) {
    result = form.value.business?.saleInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onSalesSelect = async (item: any, index: any) => {
  if (item.salePlatformId === null || item.salePlatformId === -9) {
    formRef.value?.validate([['business', 'saleInfo', index, 'percent']])
  }
}
/// 用来校验多个列表的输入框加起来要等于100之后让validator提示消失
const onSalesInput = async () => {
  const salesList = form.value.business.saleInfo
  const validList = salesList?.map((item: any, index: number) => {
    if (item.salePlatformId != null && item.percent != null) {
      return ['business', 'saleInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const logisticsProviderInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入物流商占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.currentLogisticsProvider && item.currentLogisticsProvider !== -9) ? Promise.reject(new Error('请输入物流商占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (form.value.business && form.value.business.logisticsProviderInfo) {
    result = form.value.business?.logisticsProviderInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('物流商占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onLogisticsProviderSelect = async (item: any, index: any) => {
  if (item.currentLogisticsProvider === null || item.currentLogisticsProvider === -9) {
    formRef.value?.validate([['business', 'logisticsProviderInfo', index, 'percent']])
  }
}
const onLogisticsProviderInput = async () => {
  const logistics = form.value.business.logisticsProviderInfo
  const validList = logistics?.map((item: any, index: number) => {
    if (item.currentLogisticsProvider != null && item.percent != null) {
      return ['business', 'logisticsProviderInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const goodsCategoryInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (props.perfect) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入品类占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.goodsCategory && item.goodsCategory !== -9) ? Promise.reject(new Error('请输入品类占比')) : Promise.resolve()
    }
  }
  if (value == null || value === 0) {
    return Promise.reject(new Error('请输入品类占比'))
  }
  let result = 0
  if (form.value.business && form.value.business.goodsCategoryInfo) {
    result = form.value.business?.goodsCategoryInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('品类占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onGoodsCategorySelect = async (item: any, index: any) => {
  if (item.goodsCategory === null || item.goodsCategory === -9) {
    formRef.value?.validate([['business', 'goodsCategoryInfo', index, 'percent']])
  }
}
const onGoodsCategoryInput = async () => {
  const goodsCategoryInfos = form.value.business.goodsCategoryInfo
  const validList = goodsCategoryInfos?.map((item: any, index: number) => {
    if (item.goodsCategory != null && item.percent != null) {
      return ['business', 'goodsCategoryInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const status = computed(() => {
  if (route.path.includes('/lbu/potential/add')) {
    // 新增潜在，不能选择无合作可能
    return cloneDeep(dataConfig.potentialStatusEnum).map((item: any) => {
      if (item.value === 13) {
        item.disabled = true
      }
      return item
    })
  } else if (route.path.includes('/lbu/turnToDeal')) {
    // 转成交，不能选择 流失
    // return cloneDeep(dataConfig.clientsEditStatusEnum).map((item: any) => {
    //   if (item.value === 36) {
    //     item.disabled = true
    //   }
    //   return item
    // })
    return cloneDeep(dataConfig.clientsStatusEnum).map((item: any) => {
      const findIndex = dataConfig.clientsEditStatusEnum.findIndex((i: any) => i.value && i.value === item.value)
      item.disabled = findIndex === -1 || item.value === 36
      return item
    })
  }
  if (props.type === 'potential') {
    return dataConfig.potentialStatusEnum
  } else if (props.type === 'clients') {
    return cloneDeep(dataConfig.clientsStatusEnum).map((item: any) => {
      const findIndex = dataConfig.clientsEditStatusEnum.findIndex((i: any) => i.value && i.value === item.value)
      item.disabled = findIndex === -1
      return item
    })
  }
  return []
})
const formRef = ref()
const loading = ref(false)
const channelDisabled = ref(false)
const paramCodeData = ref<any>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_department_title: [],
  lbu_customer_grade: [],
  lbu_loss_reason: [],
  lbu_invalid_reason: [],
  lbu_important: [],
  lbu_customer_size: [],
  lbu_source_channel: []
})

// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_department_title',
      'lbu_customer_grade',
      'lbu_loss_reason',
      'lbu_invalid_reason',
      'lbu_important',
      'lbu_customer_size',
      'lbu_sign_in_address_label',
      'lbu_source_channel'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data

      if (props.isEdit) {
        channelDisabled.value = isChannelDisabled(paramCodeData.value.lbu_source_channel || [], form.value.customerInfo?.channel)
      }
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const handleSubmit = async () => {
  submitForm(false)
}
const submitForm = async (coverFlag: Boolean) => {
  loading.value = true

  // 清掉无效原因，流失原因
  try {
    let res: any
    let messageTxt: string
    // 地址为空清除、判断地址是否重复
    const p = cloneDeep(form.value)
    if (checkAddressData(form.value.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    p.business.saleInfo = p.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    p.business.demandInfo = p.business.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    p.business.erpInfo = p.business.erpInfo?.filter((item: any) => {
      return item.erpId != null
    })
    p.business.goodsCategoryInfo = p.business.goodsCategoryInfo?.filter((item: any) => {
      return item.goodsCategory != null && item.percent != null
    })
    p.business.logisticsProviderInfo = p.business.logisticsProviderInfo?.filter((item: any) => {
      return item.currentLogisticsProvider != null && item.percent != null
    })
    p.business.tpr = p.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    p.business.totalPotential = p.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    const { visitAddress } = p
    p.visitAddress = clear(visitAddress, ['addressName'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(p.visitAddress) === '[{}]') {
      p.visitAddress = { attrList: [] }
    } else {
      p.visitAddress = { attrList: p.visitAddress }
    }
    if (route.path.includes('/lbu/turnToDeal')) {
      res = await turnedDeal(
        {
          ...p,
          coverFlag // 是否覆盖客户
        },
        { custom: { errorMsg: false } }
      )
      messageTxt = '转成交成功'
    } else {
      if (route.query.cosId) {
        // 处理联系人关联ID
        const { contact, customerInfo } = form.value
        if (!contact.contactRefId) {
          contact.contactRefId = customerInfo?.cosId
        }
        res = await potentialEdit(
          {
            ...p,
            coverFlag // 是否覆盖客户
          },
          { custom: { errorMsg: false } }
        )
        messageTxt = '编辑成功'
      } else {
        res = await potentialAdd(
          {
            ...p,
            coverFlag // 是否覆盖客户
          },
          { custom: { errorMsg: false } }
        )
        messageTxt = '新增成功'
      }
    }
    // 判断名称是否重复
    if (res.code === 12000025) {
      DcConfirm.warning({
        title: '操作提示！',
        content: '系统内已有相同客户名的数据，是否继续添加？',
        cancelText: '取消',
        okText: '继续',
        onOk() {
          submitForm(true)
        }
      })
    } else if (res.code === 200) {
      DcMessage.success(messageTxt)
      goBack()
    } else {
      DcMessage.error(res.message)
    }
  } catch (error) {}
  loading.value = false
}
// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "基本信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'customerName'],
              label: "客户名称",
              rules: {
          message: '请输入',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInputTianyancha, {
                  value: form.value.customerInfo.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerInfo.customerName) = $event)),
                  view: __props.view,
                  appId: "cos_lbu",
                  maxlength: 50,
                  disabled: __props.type === 'clients' && !permissionBtn.value.includes('lbu_clients_edit_name_or_code_btn') ? true : false
                }, null, 8, ["value", "view", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'status'],
              label: "状态",
              rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value
                      }, [
                        _createElementVNode("p", null, _toDisplayString(item.label) + "：" + _toDisplayString(item.desc), 1)
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerInfo.status,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerInfo.status) = $event)),
                  allowClear: "",
                  placeholder: "请选择",
                  options: status.value,
                  view: __props.view,
                  disabled: __props.type === 'potential' ? true : false
                }, null, 8, ["value", "options", "view", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "来源渠道",
              name: ['customerInfo', 'channel'],
              rules: {
          required: true,
          message: '请选择'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: form.value.customerInfo.channel,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerInfo.channel) = $event)),
                      appId: "cos_lbu",
                      paramCode: "lbu_source_channel",
                      status: __props.view ? undefined : 0,
                      style: {"width":"33%"},
                      view: __props.view,
                      disabled: !props.isEdit || channelDisabled.value,
                      cosDes: form.value.customerInfo.channelExplain
                    }, null, 8, ["value", "status", "view", "disabled", "cosDes"]),
                    _createVNode(_component_a_form_item, {
                      style: {"width":"67%"},
                      class: "last-compact",
                      name: "channelExplain"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosInput, {
                          value: form.value.customerInfo.channelExplain,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.customerInfo.channelExplain) = $event)),
                          maxlength: 50,
                          placeholder: "请输入",
                          view: __props.view,
                          disabled: !props.isEdit || channelDisabled.value
                        }, null, 8, ["value", "view", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.disabled)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "客户负责人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.customerInfo.sellerName,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.customerInfo.sellerName) = $event)),
                      view: __props.view
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "客户代码",
              name: ['customerInfo', 'tmsCode']
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.customerInfo.tmsCode,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.customerInfo.tmsCode) = $event)),
                  view: __props.view,
                  maxlength: 10,
                  placeholder: "请输入",
                  disabled: true
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户类型",
              name: ['customerInfo', 'type'],
              rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerInfo.type,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.customerInfo.type) = $event)),
                  options: _unref(dataConfig).customerTypeEnum,
                  placeholder: "请选择",
                  "allow-clear": "",
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (__props.perfect)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: "客户等级",
                  name: ['customerInfo', 'grade'],
                  rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: __props.type === 'clients'
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: form.value.customerInfo.grade,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.customerInfo.grade) = $event)),
                      options: paramCodeData.value.lbu_customer_grade,
                      view: __props.view
                    }, null, 8, ["value", "options", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, { label: "客户规模" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.lbu_customer_size,
                  value: form.value.customerInfo.enterpriseScale,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.customerInfo.enterpriseScale) = $event)),
                  view: __props.view
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }),
            (__props.disabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.customerSerial,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.customerInfo.customerSerial) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号代码" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.customerNumber,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.customerInfo.customerNumber) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "ID" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.cosId,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.customerInfo.cosId) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "客户合同地址",
              name: ['customerInfo', 'customerAddress']
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.customerInfo.customerAddress,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.customerInfo.customerAddress) = $event)),
                  maxlength: 200,
                  disabled: true,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "客户标签" }, {
              default: _withCtx(() => [
                _createVNode(CustomerLabelCascader, {
                  disabled: !props.isEdit,
                  view: __props.view,
                  type: "search",
                  appId: "cos_lbu",
                  ids: form.value.customerInfo.labelIdList,
                  "onUpdate:ids": _cache[13] || (_cache[13] = ($event: any) => ((form.value.customerInfo.labelIdList) = $event)),
                  value: form.value.customerInfo.labelIdList,
                  allowClear: ""
                }, null, 8, ["disabled", "view", "ids", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "是否上市" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.customerInfo.listedFlag,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.customerInfo.listedFlag) = $event)),
                  options: _unref(dataConfig).flagEnum,
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            (__props.type === 'clients' && __props.view)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 3,
                  label: "结算模式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.customerInfo.settlementType,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.customerInfo.settlementType) = $event)),
                      options: _unref(dataConfig).settlementTypeEnum,
                      disabled: true,
                      placeholder: "请选择",
                      allowClear: "",
                      view: __props.view
                    }, null, 8, ["value", "options", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.type === 'clients')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  label: "渠道代码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      disabled: "",
                      value: form.value.customerInfo.tmsChannelCode,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.customerInfo.tmsChannelCode) = $event)),
                      maxlength: 200,
                      view: __props.view,
                      placeholder: "--"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "业务类型",
              name: ['customerInfo', 'businessType'],
              rules: [{
          message: '请选择',
          required: true
        }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerInfo.businessType,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.customerInfo.businessType) = $event)),
                  options: _unref(dataConfig).businessTypeEnum,
                  disabled: !props.isEdit,
                  placeholder: "请选择",
                  allowClear: "",
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            (__props.disabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createVNode(_component_dc_form_item, {
                    name: "customerRegion",
                    label: "客户区域"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        appId: "cos_lbu",
                        value: form.value.customerInfo.customerRegion,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.customerInfo.customerRegion) = $event)),
                        view: __props.view
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "剩余跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.remanentFollowDays,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.customerInfo.remanentFollowDays) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.unfollowDays,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.customerInfo.unfollowDays) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.createByName,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.customerInfo.createByName) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.createTime,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.customerInfo.createTime) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "首次领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.firstReceiveTime,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.customerInfo.firstReceiveTime) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "最后领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.lastReceiveTime,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.customerInfo.lastReceiveTime) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "转潜在时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.turnedPotential,
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.customerInfo.turnedPotential) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  (form.value.customerInfo.status > 29)
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        label: "转为成交时间"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CosInput, {
                            value: form.value.customerInfo.turnedTransaction,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.customerInfo.turnedTransaction) = $event)),
                            view: __props.view,
                            placeholder: "请输入"
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_dc_form_item, { label: "更新时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: form.value.customerInfo.updateTime,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.customerInfo.updateTime) = $event)),
                        view: __props.view,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (__props.content.includes('contact'))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "联系人信息"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "联系人姓名",
                  name: ['contact', 'name'],
                  rules: [
          {
            message: '请输入',
            required: true
          },
          {
            validator: _unref(concatNameValidate)
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.name,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.contact.name) = $event)),
                      view: __props.view,
                      maxlength: 50,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  name: ['contact', 'mobile'],
                  label: "手机号",
                  rules: { required: form.value.customerInfo.businessType === 1,
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value, form.value.customerInfo.businessType === 1)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.mobile,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((form.value.contact.mobile) = $event)),
                      view: __props.view,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  name: ['contact', 'email'],
                  label: "邮箱",
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value, form.value.customerInfo.businessType === 1)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.email,
                      "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((form.value.contact.email) = $event)),
                      view: __props.view,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  name: ['contact', 'wechat'],
                  label: "微信号",
                  rules: { required: form.value.customerInfo.businessType === 1,
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value, form.value.customerInfo.businessType === 1)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.wechat,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((form.value.contact.wechat) = $event)),
                      view: __props.view,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  name: ['contact', 'qq'],
                  label: "QQ号",
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value, form.value.customerInfo.businessType === 1)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.qq,
                      "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((form.value.contact.qq) = $event)),
                      view: __props.view,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  name: ['contact', 'tel'],
                  label: "固定电话",
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value, form.value.customerInfo.businessType === 1)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.tel,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((form.value.contact.tel) = $event)),
                      view: __props.view,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, { label: "传真号" }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.fax,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((form.value.contact.fax) = $event)),
                      view: __props.view,
                      maxlength: 50,
                      placeholder: "请输入"
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "性别" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: form.value.contact.sex,
                      "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((form.value.contact.sex) = $event)),
                      options: _unref(dataConfig).genderEnum
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "角色",
                  name: ['contact', 'jobRole'],
                  rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.contact.jobRole,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((form.value.contact.jobRole) = $event)),
                      options: _unref(dataConfig).linkRoleTypeEnum,
                      placeholder: "请选择",
                      "allow-clear": "",
                      view: __props.view
                    }, null, 8, ["value", "options", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "职务",
                  name: ['contact', 'jobDuty'],
                  rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: form.value.contact.jobDuty,
                      "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((form.value.contact.jobDuty) = $event)),
                      view: __props.view,
                      options: paramCodeData.value.lbu_department_title
                    }, null, 8, ["value", "view", "options"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "备注",
                  span: 12,
                  name: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.contact.remark,
                      "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((form.value.contact.remark) = $event)),
                      maxlength: 2000,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_dc_layout_card, {
          title: "签到地址（添加后才能签到打卡）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (!__props.disabled)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_unref(handleAddressAdd)(form.value.visitAddress)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.visitAddress, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '签到地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressName'],
                      rules: {
                    message: '请选择',
                    required: __props.isEditPotentialOrDeal
                  }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(MapModal, {
                          address: item.addressName,
                          "onUpdate:address": ($event: any) => ((item.addressName) = $event),
                          geoPoint: item.geoPoint,
                          "onUpdate:geoPoint": ($event: any) => ((item.geoPoint) = $event),
                          view: __props.view
                        }, null, 8, ["address", "onUpdate:address", "geoPoint", "onUpdate:geoPoint", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '补充地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'suppAddress'],
                      rules: {
                    message: '请输入',
                    required: __props.isEditPotentialOrDeal
                  }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosInput, {
                          value: item.suppAddress,
                          "onUpdate:value": ($event: any) => ((item.suppAddress) = $event),
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '地址类型',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressTag'],
                      rules: {
                    // message: '请选择',
                    validator:  (rule, value) => checkAddressValidate(rule, value, form.value.visitAddress),
                    required: __props.isEditPotentialOrDeal
                  }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.lbu_sign_in_address_label,
                            value: item.addressTag,
                            "onUpdate:value": ($event: any) => ((item.addressTag) = $event),
                            disabled: __props.disabled,
                            view: __props.view,
                            allowClear: "",
                            style: {"width":"100%"}
                          }, null, 8, ["options", "value", "onUpdate:value", "disabled", "view"]),
                          (!__props.disabled && form.value.visitAddress && form.value.visitAddress.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (_unref(handleAddressAddDel)(index, form.value.visitAddress))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_checkbox, {
                            style: {"padding":"3px 0 0 12px","width":"150px"},
                            disabled: __props.view,
                            checked: item.mainAddressFlag === 1,
                            onChange: ($event: any) => (clearMainAddressFlag(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("主要")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "checked", "onChange"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 6 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "业务信息" }, {
          default: _withCtx(() => [
            (!__props.perfect)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "业务收入等级",
                  name: ['business', 'monthIncome']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.lbu_important,
                      value: form.value.business.monthIncome,
                      "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((form.value.business.monthIncome) = $event)),
                      view: __props.view
                    }, null, 8, ["options", "value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "年销售GMV（元）",
              name: ['business', 'annualSales']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInputNumber, {
                  value: form.value.business.annualSales,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((form.value.business.annualSales) = $event)),
                  "cos-type": "money",
                  maxlength: 15,
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"},
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "总TPR（票数/月）" }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: tprPotential.value,
                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((tprPotential).value = $event)),
                  placeholder: "自动计算",
                  maxlength: 100,
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "总TPR（元/月）" }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: tprTotal.value,
                  "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((tprTotal).value = $event)),
                  placeholder: "自动计算",
                  maxlength: 100,
                  "cos-type": "money",
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            (form.value.customerInfo.businessType === 1)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: "总TPR（KG/月）"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_a_tooltip, {
                      placement: "topLeft",
                      overlayStyle: { maxWidth: '800px' }
                    }, {
                      title: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: totalTprWeight.value,
                      placeholder: "自动计算",
                      maxlength: 100,
                      disabled: true,
                      view: __props.view
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.view)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_dc_form_item, { label: "主账号上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.uitQty,
                        "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((form.value.business.uitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号去年上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.lyUitQty,
                        "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((form.value.business.lyUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号前三个月平均发货票数" }, {
                    label: _withCtx(() => [
                      _createVNode(_component_a_tooltip, {
                        placement: "topLeft",
                        overlayStyle: { maxWidth: '800px' }
                      }, {
                        title: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.avgQty,
                        "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((form.value.business.avgQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.ctUitQty,
                        "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((form.value.business.ctUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号去年上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.ctLyUitQty,
                        "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((form.value.business.ctLyUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号前三个月平均发货票数" }, {
                    label: _withCtx(() => [
                      _createVNode(_component_a_tooltip, {
                        placement: "topLeft",
                        overlayStyle: { maxWidth: '800px' }
                      }, {
                        title: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.ctAvgQty,
                        "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((form.value.business.ctAvgQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR金额" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.totalOprAmount,
                        "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((form.value.business.totalOprAmount) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.totalOprMau,
                        "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((form.value.business.totalOprMau) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR重量" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.totalOprWeight,
                        "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((form.value.business.totalOprWeight) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR方数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.business.totalOprCube,
                        "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((form.value.business.totalOprCube) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "在售平台" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[54] || (_cache[54] = ($event: any) => (handleAddCol(form.value.business.saleInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.saleInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `saleInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售电商平台',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'saleInfo', index, 'salePlatformId'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        salePlatformId: item.salePlatformId,
                        percent: item.percent
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.lbu_sale_platform,
                          value: item.salePlatformId,
                          "onUpdate:value": ($event: any) => ((item.salePlatformId) = $event),
                          view: __props.view,
                          onChange: ($event: any) => (onSalesSelect(item,index))
                        }, null, 8, ["options", "value", "onUpdate:value", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售平台占比(%)',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'saleInfo', index, 'percent'],
                      rules: [{required: __props.perfect, validator: (rule, value) => percentValidate(rule,value,item)}]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            placeholder: "请输入",
                            style: {"width":"100%"},
                            min: 0,
                            onChange: onSalesInput,
                            view: __props.view
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.saleInfo && form.value.business.saleInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.saleInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "目的地国家" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (handleAddCol(form.value.business.demandInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.demandInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `demandInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '目的地国家',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'demandInfo', index, 'countryId'],
                      span: 4,
                      rules: {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: __props.perfect
                  }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.lbu_demand_country,
                          value: item.countryId,
                          "onUpdate:value": ($event: any) => ((item.countryId) = $event),
                          view: __props.view
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '出货渠道',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'shippingChannel'],
                      span: 4,
                      rules: {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: __props.perfect
                  }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.shippingChannel,
                          "onUpdate:value": ($event: any) => ((item.shippingChannel) = $event),
                          options: paramCodeData.value.lbu_shipping_channel,
                          view: __props.view,
                          mode: "multiple"
                        }, null, 8, ["value", "onUpdate:value", "options", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（票数/月）',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'demandInfo', index, 'potentialBusinessVolume'],
                      span: 4,
                      rules: {
                    message: '请输入',
                    required: __props.perfect
                  }
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_19
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（票数/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.potentialBusinessVolume,
                          "onUpdate:value": ($event: any) => ((item.potentialBusinessVolume) = $event),
                          min: 0,
                          maxlength: 15,
                          "cos-type": "money",
                          style: {"width":"100%"},
                          placeholder: "请输入",
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（元/月）',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      span: 4,
                      name: ['business', 'demandInfo', index, 'amount'],
                      rules: {
                    message: '请输入',
                    required: __props.perfect
                  }
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_20
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（元/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.amount,
                          "onUpdate:value": ($event: any) => ((item.amount) = $event),
                          min: 0,
                          maxlength: 15,
                          "cos-type": "money",
                          style: {"width":"100%"},
                          placeholder: "请输入",
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（KG/月）',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      span: 6,
                      name: ['business', 'demandInfo', index, 'tprWeight']
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_21
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（KG/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.tprWeight,
                            "onUpdate:value": ($event: any) => ((item.tprWeight) = $event),
                            min: 0,
                            maxlength: 15,
                            "cos-type": "money",
                            view: __props.view,
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.demandInfo && form.value.business.demandInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.demandInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 24 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "物流商（务必填写云途份额）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              (props.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (!__props.disabled)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          ghost: "",
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (handleAddCol(form.value.business.logisticsProviderInfo)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.logisticsProviderInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `logisticsProviderInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '当前物流商',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'logisticsProviderInfo', index, 'currentLogisticsProvider'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        currentLogisticsProvider: item.currentLogisticsProvider,
                        percent: item.percent
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          options: paramCodeData.value.lbu_logistics_service_provider,
                          value: item.currentLogisticsProvider,
                          "onUpdate:value": ($event: any) => ((item.currentLogisticsProvider) = $event),
                          view: __props.view,
                          onChange: ($event: any) => (onLogisticsProviderSelect(item, index))
                        }, null, 8, ["options", "value", "onUpdate:value", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '物流商占比(%)',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'logisticsProviderInfo', index, 'percent'],
                      rules: [{required: __props.perfect, validator: (rule, value) => logisticsProviderInfoValidate(rule,value,item)}]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            placeholder: "请输入",
                            style: {"width":"100%"},
                            min: 0,
                            onChange: onLogisticsProviderInput,
                            view: __props.view
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.logisticsProviderInfo && form.value.business.logisticsProviderInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.logisticsProviderInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "货物品类" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[57] || (_cache[57] = ($event: any) => (handleAddCol(form.value.business.goodsCategoryInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.goodsCategoryInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `goodsCategoryInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '货物品类',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'goodsCategoryInfo', index, 'goodsCategory'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        goodsCategory: item.goodsCategory,
                        percent: item.percent
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.lbu_sales_category,
                          value: item.goodsCategory,
                          "onUpdate:value": ($event: any) => ((item.goodsCategory) = $event),
                          view: __props.view,
                          onChange: ($event: any) => (onGoodsCategorySelect(item,index))
                        }, null, 8, ["options", "value", "onUpdate:value", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '品类占比(%)',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'goodsCategoryInfo', index, 'percent'],
                      rules: [{required: __props.perfect,validator: (rule, value) => goodsCategoryInfoValidate(rule,value,item)}]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            placeholder: "请输入",
                            style: {"width":"100%"},
                            min: 0,
                            onChange: onGoodsCategoryInput,
                            view: __props.view
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.goodsCategoryInfo && form.value.business.goodsCategoryInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.goodsCategoryInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "ERP系统" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[58] || (_cache[58] = ($event: any) => (handleAddCol(form.value.business.erpInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.view,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.erpInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `erpInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'ERP系统',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'erpInfo', index, 'erpId'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        erpId: item.erpIdLabel,
                        erpAccount: item.erpAccount
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.lbu_erp_info,
                          view: __props.view,
                          value: item.erpId,
                          "onUpdate:value": ($event: any) => ((item.erpId) = $event)
                        }, null, 8, ["options", "view", "value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '关联账号',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'erpInfo', index, 'erpAccount']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(CosInput, {
                            value: item.erpAccount,
                            "onUpdate:value": ($event: any) => ((item.erpAccount) = $event),
                            view: __props.view,
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.erpInfo && form.value.business.erpInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.erpInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        (form.value.customerInfo.status === 13 || form.value.customerInfo.status === 36)
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 1,
              title: "其他原因"
            }, {
              default: _withCtx(() => [
                (form.value.customerInfo.status === 13)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_dc_form_item, {
                        label: "无效原因",
                        name: ['customerInfo', 'invalidReason'],
                        span: 12,
                        rules: {
            message: '请选择',
            validator: _unref(selectForNumberValidate),
            required: true
          }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.lbu_invalid_reason,
                            value: form.value.customerInfo.invalidReason,
                            "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => ((form.value.customerInfo.invalidReason) = $event)),
                            view: __props.view
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: "说明",
                        name: ['customerInfo', 'directions'],
                        span: 12,
                        rules: {
            message: '请输入',
            required: true
          }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CosInput, {
                            value: form.value.customerInfo.directions,
                            "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((form.value.customerInfo.directions) = $event)),
                            placeholder: "请输入",
                            maxlength: 200,
                            view: __props.view
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                (form.value.customerInfo.status === 36)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_dc_form_item, {
                        label: "流失原因",
                        name: ['customerInfo', 'loseReason'],
                        span: 12,
                        rules: {
            message: '请选择',
            validator: _unref(selectForNumberValidate),
            required: true
          }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.lbu_loss_reason,
                            value: form.value.customerInfo.loseReason,
                            "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((form.value.customerInfo.loseReason) = $event)),
                            view: __props.view
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: "具体原因",
                        name: ['customerInfo', 'loseDirections'],
                        span: 12,
                        rules: {
            message: '请输入',
            required: true
          }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CosInput, {
                            value: form.value.customerInfo.loseDirections,
                            "onUpdate:value": _cache[62] || (_cache[62] = ($event: any) => ((form.value.customerInfo.loseDirections) = $event)),
                            placeholder: "请输入",
                            maxlength: 200,
                            view: __props.view
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_dc_layout_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "上传附件",
              name: ['customerInfo', 'attachmentId'],
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: form.value.customerInfo.attachmentId,
                  "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((form.value.customerInfo.attachmentId) = $event)),
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              name: ['customerInfo', 'remark'],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.customerInfo.remark,
                  "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((form.value.customerInfo.remark) = $event)),
                  placeholder: "请输入",
                  maxlength: 2000,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          resetValue: resetValue.value,
          value: form.value,
          "onUpdate:value": _cache[65] || (_cache[65] = ($event: any) => ((form).value = $event)),
          formRef: formRef.value,
          loading: loading.value,
          returnName: __props.returnName,
          onSubmit: handleSubmit,
          disabled: __props.disabled,
          hideOk: __props.hideOk,
          permissionPage: __props.permissionPage
        }, null, 8, ["resetValue", "value", "formRef", "loading", "returnName", "disabled", "hideOk", "permissionPage"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})